import { LinkOption, AllowedActionMenuElements } from 'ui/actionMenu/types';
import { Import16 } from 'ui/icons';
import { useTranslation } from 'modules/domains/list';
import { createEmailListIdParams } from '../../../utils';
import { LIST_UPDATE_URL } from '../../../constants';
import { List } from '../../../types';

export const useAddUsersOrModifyListLink = (list: List): LinkOption => {
  const { t } = useTranslation();
  const href = createEmailListIdParams(list, LIST_UPDATE_URL);

  return {
    as: AllowedActionMenuElements.Link,
    href,
    content: (
      <>
        <Import16 />
        <span>{t('indexPage.table.overflowMenu.update')}</span>
      </>
    ),
    id: 'list-update-link',
  };
};
